import { render, staticRenderFns } from "./ExDetail.vue?vue&type=template&id=018e185b&scoped=true&"
import script from "./ExDetail.vue?vue&type=script&lang=js&"
export * from "./ExDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExDetail.vue?vue&type=style&index=0&id=018e185b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018e185b",
  null
  
)

export default component.exports